import type { ElementType } from "@/react/types/Element";
import { ButtonElement } from "../ElementTypes/ButtonElement";
import { FieldElement } from "../ElementTypes/FieldElement";
import { TextElement } from "../ElementTypes/TextElement";

interface RenderElementProps {
  className?: string;
  element: ElementType;
  errors: Record<number, string>;
  fieldIndex: number;
  initialFocusRef?: React.RefObject<HTMLInputElement>;
  isPreview: boolean;
  isSubmitting: boolean;
}
export const FormElement = ({
  element,
  isPreview,
  isSubmitting,
  initialFocusRef,
  fieldIndex,
  errors,
  className,
}: RenderElementProps) => {
  switch (element.type) {
    case "text":
      return <TextElement element={element} />;
    case "field":
      return (
        <FieldElement
          element={element}
          initialFocusRef={initialFocusRef}
          fieldIndex={fieldIndex}
          className={className}
          errors={errors}
        />
      );
    case "button":
      return (
        <ButtonElement
          element={element}
          isPreview={isPreview}
          isSubmitting={isSubmitting}
          className={className}
        />
      );
    default:
      return null;
  }
};
